import type { Operation } from "@apollo/client";

export const AUTH_TOKEN_STORAGE_KEY = "authToken";
export const SUPABASE_STORAGE_KEY = "ugg-supabase-auth";
export const UGG_ACCOUNT_STORAGE_KEY = "ugg-account-user-id";
export const AUTH_API_CLIENT_NAME = "auth-api";

export const getAuthTokenBrowser = () => localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
export const setAuthTokenBrowser = (token: string | null | undefined) => {
  const value = token ?? "";
  localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, value);
};
export const bearerAuthHeader = (token: string | undefined | null) => {
  if (!token) {
    return {};
  }

  return { authorization: `Bearer ${token}` };
};

export const isAuthOperation = (op: Operation) => op.getContext().clientName === AUTH_API_CLIENT_NAME;
